<svg width="40px" height="45px" viewBox="0 0 40 45" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>copy-some</title>
    <g id="Campaign-Management" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="Copy-Items" transform="translate(-192.000000, -362.000000)" fill="#000000" fill-rule="nonzero">
        <g id="Modal" transform="translate(52.000000, 63.000000)">
          <g id="Campiagn-type-cell" transform="translate(79.000000, 258.000000)">
            <g id="copy-some" transform="translate(61.000000, 41.000000)">
              <path d="M0,45.0016273 L27.5010397,45.0016273 L27.5010397,12.5003164 L0,12.5003164 L0,45.0016273 Z M2.49986439,15 L25.0006328,15 L25.0006328,42.5010397 L2.49986439,42.5010397 L2.49986439,15 Z" id="Shape" opacity="0.12"></path>
              <polygon id="Path" fill="red" points="7.4999548 8.75033902 31.2510171 8.75033902 31.2510171 37.5016725 33.7512431 37.5016725 33.7512431 6.24975139 7.49959318 6.24975139"></polygon>
              <polygon id="Path" opacity="0.122301374" points="13.7505198 1.92708717e-15 13.7505198 2.50058763 37.499774 2.50058763 37.499774 31.2510171 40 31.2510171 40 0"></polygon>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>